// extracted by mini-css-extract-plugin
export default {"iata":"xxC55","additionalInfo":"PnCjB","transparent":"D3gyo","AirportIcon":"lsyx0","RailwaysIcon":"Uac-2","HotelsIcon":"aMX2c","MapPointIcon":"r5Pku","skeleton-progress":"_0PO7b"};